import React from "react";
import NavbarHeader from "./NavbarHeader"
import HeaderSearch from "../HeaderSearch";

import logo from "../../../assets/images/logo.png";

export default function Navbar(){
    return (
        <nav className="navigation navbar navbar-default">
            <div className="container">
                <NavbarHeader logo={logo}/>
                <div id="navbar" className="navbar-collapse collapse navbar-right navigation-holder">
                <button className="close-navbar"><i className="ti-close"></i></button>
                    <ul className="nav navbar-nav">
                        <li><a href="/">Úvod</a></li>
                        <li><a href="/o-mne">O mne</a></li>
                        <li><a href="/program">Program</a></li>
                        <li><a href="/aktuality">Aktuality</a></li>
                        <li><a href="/kontakt">Kontakt</a></li>
                    </ul>
                </div>
                <div className="cart-search-contact">
                    <HeaderSearch />
                </div>
            </div>
        </nav>
    )
}